import { Injectable } from "@angular/core";
import { ConnectionServices } from "../authentication/connection/connection.service";
import { IdentityService } from "../authentication/identity.service";
import { BehaviorSubject, catchError, map, Observable, throwError } from "rxjs";
import { CheckingAccountTotalsResponseDTO, OwnersCheckingAccountResponseDTO, GetAffiliateLiquidationDTO } from "../authentication/connection/interfaces/apiInterfaces";
import { GetClientsCheckingAccountTotalsCommand } from "./command/getClientsCheckingAccountTotals.command";
import { IGetDriversCheckingAccountCommandParameters } from "./command/getDriversCheckingAccounts.command";
import { GetCheckingAccountClientCommand } from "./command/getCheckingAccountClient.command";
import { CheckingAccountsResponseDTO } from "./checking-account-client.dto";
import { GetCheckingAccountClientDetailCommand, MBClientSummaryDTO } from "./command/getCheckingAccountClientDetail.command";
import { GetAffiliateLiquidationCommand } from "./command/getAffiliateLiquidation.command";
import { AddCheckingAccountLiquidationCommand } from "./command/addCheckingAccountLiquidation.command";
import { DeleteAffiliateLiquidationCommand } from "./command/deleteAffiliateLiquidation.command";
import { GetOwnersCheckingAccountsCommand, IGetOwnersCheckingAccountCommandParameters } from "./command/getOwnersCheckingAccounts.command";


@Injectable()
export class CheckingAccountsService {
  private checkingAccountId$ = new BehaviorSubject<any>({});
  private nameCarrier$ = new BehaviorSubject<any>({});
  private liquidationDetailIDs$ = new BehaviorSubject<any>({});
  private liquidationDetailTotal$ = new BehaviorSubject<any>({});

  constructor(
    private _connectionService: ConnectionServices,
    private _identityService: IdentityService
  ) {}

  setIdCheckingAccount(data: any) {
    this.checkingAccountId$.next(data);
  }

  getIdCheckingAccount(): Observable<any> {
    return this.checkingAccountId$.asObservable();
  }

  setNameCarrier(data: any) {
    this.nameCarrier$.next(data);
  }

  getNameCarrier(): Observable<any> {
    return this.nameCarrier$.asObservable();
  }

  setLiquidationDetailId(data: any) {
    this.liquidationDetailIDs$.next(data);
  }

  getLiquidationDetailIDs(): Observable<any> {
    return this.liquidationDetailIDs$.asObservable();
  }

  setLiquidationDetailTotal(data: any) {
    this.liquidationDetailTotal$.next(data);
  }

  getLiquidationDetailTotal(): Observable<any> {
    return this.liquidationDetailTotal$.asObservable();
  }

  // setIdCheckingAccount(data: any) {
  //   this.checkingAccountId$.next(data);
  // }

  // getIdCheckingAccount(): Observable<any> {
  //   return this.checkingAccountId$.asObservable();
  // }

  // setCheckingAccountDetailsData(data: any) {
  //   this.checkingAccountDetailsData$.next(data);
  // }

  // getCheckingAccountDetailsData(): Observable<any> {
  //   return this.checkingAccountDetailsData$.asObservable();
  // }

  // setNameCarrier(data: any) {
  //   this.nameCarrier$.next(data);
  // }

  // getNameCarrier(): Observable<any> {
  //   return this.nameCarrier$.asObservable();
  // }

  // setLiquidationDetailId(data) {
  //   this.liquidationDetailIDs$.next(data);
  // }

  // getLiquidationDetailIDs() {
  //   return this.liquidationDetailIDs$.asObservable();
  // }

  // setLiquidationDetailTotal(data) {
  //   this.liquidationDetailTotal$.next(data);
  // }

  // getLiquidationDetailTotal() {
  //   return this.liquidationDetailTotal$.asObservable();
  // }

  // getDriversCheckingAccountsList(
  //   numberPage: number,
  //   rowsOnPage: number,
  //   column: string,
  //   sort: SortEnum,
  //   find: string
  // ): Observable<DriversCheckingAccountResponseDTO> {
  //   const getDriversCheckingAccountsCommand =
  //     new GetDriversCheckingAccountsCommand();
  //   getDriversCheckingAccountsCommand.setParameters(<
  //     IGetDriversCheckingAccountCommandParameters
  //   >{
  //     carrierId: +this._identityService.userId,
  //     page: numberPage,
  //     column: column,
  //     size: rowsOnPage,
  //     find: find,
  //     sort: sort,
  //   });
  //   return this._connectionService
  //     .Request(getDriversCheckingAccountsCommand)
  //     .map((response) => {
  //       return response;
  //     })
  //     .catch((error) => {
  //       this._notificationService.showHttpErrorMessage(
  //         'toast.checking_accounts.driver',
  //         error
  //       );
  //       return Observable.throw(false);
  //     });
  // }

  getOwnersCheckingAccountsList(
    column: string,
    page: number,
    size: number,
    sort: string,
    find: string
  ): Observable<OwnersCheckingAccountResponseDTO> {
    const command = new GetOwnersCheckingAccountsCommand();
    command.setParameters(<IGetOwnersCheckingAccountCommandParameters>{
      carrierId: +this._identityService.userId,
      page: page,
      column: column,
      size: size,
      find: find,
      sort: sort,
    });
    return this._connectionService
      .Request(command)
      .pipe(
        map(data => data as OwnersCheckingAccountResponseDTO),
        catchError(() => throwError(() => false))
      );
  }

  getCheckingAccountClientPaginated(
    column: string,
    page: number,
    size: number,
    sort: string,
    find: string,
    typeFilter: string
  ): Observable<CheckingAccountsResponseDTO> {
    // checking-accounts/carrier/1040/clients/paginated?page=1&size=20&column=id&sort=ASC&find=
    const command = new GetCheckingAccountClientCommand();
    command.setParameters({
      carrierId: +this._identityService.userId,
      column: column,
      page: page,
      size: size,
      sort: sort,
      find: find,
      typeFilter: typeFilter
    });

    return this._connectionService
      .Request(command)
      .pipe(
        map(data => {
          const response = data as CheckingAccountsResponseDTO;
          return response;
        }),
        catchError(() => {
          return throwError(() => false);
        })
      )
  }

  getClientsTotalizedBalances(): Observable<CheckingAccountTotalsResponseDTO> {
    const getClientsCheckingAccountTotalsCommand =
      new GetClientsCheckingAccountTotalsCommand();
    getClientsCheckingAccountTotalsCommand.setParameters(<
      IGetDriversCheckingAccountCommandParameters
    >{
      carrierId: +this._identityService.userId,
    });

    return this._connectionService
      .Request(getClientsCheckingAccountTotalsCommand)
      .pipe(
        map(data => {
          const response = data as CheckingAccountTotalsResponseDTO;
          return response;
        }),
        catchError(() => {
          return throwError(() => false);
        })
      )
    // return this._connectionService
    //   .Request(getClientsCheckingAccountTotalsCommand)
    //   .map((response) => {
    //     return response;
    //   })
    //   .catch((error) => {
    //     this._notificationService.showHttpErrorMessage(
    //       'toast.checking_accounts.clients',
    //       error
    //     );
    //     return Observable.throw(false);
    //   });
  }

  getCheckingAccountClientDetail(
    paxId: number,
    dateFrom: string,
    dateTo: string
  ): Observable<MBClientSummaryDTO> {
    // checking-accounts/carrier/1040/clients/paginated?page=1&size=20&column=id&sort=ASC&find=
    const command = new GetCheckingAccountClientDetailCommand();
    command.setParameters({
      carrierId: +this._identityService.userId,
      paxId: paxId,
      dateFrom: dateFrom,
      dateTo: dateTo
    });

    return this._connectionService
      .Request(command)
      .pipe(
        map(data => {
          const response = data as MBClientSummaryDTO;
          return response;
        }),
        catchError(() => {
          return throwError(() => false);
        })
      )
  }

  // getMagiisCheckingAccountMovements(
  //   numberPage: number,
  //   rowsOnPage: number,
  //   sortField: string,
  //   sortOrder: SortEnum,
  //   startDate: any,
  //   endDate: any
  // ): Observable<MagiisCheckingAccountMovementsResponseDTO> {
  //   const magiisCheckingAccountMovementsCommand =
  //     new GetMagiisCheckingAccountCommand();
  //   magiisCheckingAccountMovementsCommand.setParameters({
  //     carrierId: +this._identityService.userId,
  //     page: numberPage,
  //     column: sortField,
  //     size: rowsOnPage,
  //     sort: sortOrder,
  //     startDate: startDate,
  //     endDate: endDate,
  //   });
  //   return this._connectionService
  //     .Request(magiisCheckingAccountMovementsCommand)
  //     .map((response) => {
  //       return response;
  //     })
  //     .catch((error) => {
  //       this._notificationService.showHttpErrorMessage(
  //         'toast.checking_accounts.magiis',
  //         error
  //       );
  //       return Observable.throw(false);
  //     });
  // }

  // saveCheckingAccountMovement(
  //   checkingAccountId: number,
  //   note: CreditDebitNoteRequestDTO
  // ) {
  //   const checkingAccountMovementsCommand =
  //     new AddClientCheckingAccountMovementCommand();
  //   checkingAccountMovementsCommand.setParameters({
  //     carrierUserId: +this._identityService.userId,
  //     checkingAccountId: checkingAccountId,
  //     amount: note.amount,
  //     noteType: note.noteType,
  //     reason: note.reason,
  //   });
  //   return this._connectionService
  //     .Request(checkingAccountMovementsCommand)
  //     .map((response) => {
  //       return response;
  //     })
  //     .catch((error) => {
  //       if (error.error.errorCode === 'INVALID_MOVEMENT') {
  //         this._notificationService.showInternalErrorMessage(
  //           'toast.checking_accounts.title',
  //           error.error.description
  //         );
  //       } else {
  //         this._notificationService.showHttpErrorMessage(
  //           'toast.checking_accounts.title',
  //           error
  //         );
  //       }
  //       return Observable.throw(false);
  //     });
  // }

  // getCheckingAccountSummaryTotals() {
  //   const magiisCheckingAccountSummaryTotalsCommand =
  //     new GetMagiisCheckingAccountSummaryTotalsCommand();
  //   magiisCheckingAccountSummaryTotalsCommand.setParameters();
  //   return this._connectionService
  //     .Request(magiisCheckingAccountSummaryTotalsCommand)
  //     .map((response) => {
  //       return response;
  //     })
  //     .catch((error) => {
  //       this._notificationService.showHttpErrorMessage(
  //         'toast.checking_accounts.magiis',
  //         error
  //       );
  //       return Observable.throw(false);
  //     });
  // }

  // getReportClientCheckingAccountPDF(carrierId: number,
  //                                   checkingAccountId: number,
  //                                   startDate: string,
  //                                   endDate: string,
  //                                   sort: string,
  //                                   column: string,
  //                                   languageCode: string,
  //                                   movementTypeFilter?: string,
  //                                   costCenterFilter?: string,
  //                                   isContractor?: boolean) {
  //   let reportClientCheckingAccount = new ReportClientCheckingAccount();

  //   reportClientCheckingAccount.setParameters({
  //     carrierId: carrierId,
  //     checkingAccountId: checkingAccountId,
  //     from: startDate,
  //     to: endDate,
  //     sort: sort,
  //     column: column,
  //     movementTypeFilter: movementTypeFilter,
  //     costCenterFilter: costCenterFilter,
  //     isContractor: isContractor,
  //     languageCode: languageCode
  //   });
  //   return this._connectionService
  //   .Request(reportClientCheckingAccount)
  //   .map(response => {
  //     return response;
  //   })
  //   .catch(error => {
  //     this._notificationService.showHttpErrorMessage(
  //       'toast.checking_accounts.detail',
  //       error
  //     );
  //     return Observable.throw(false);
  //   });
  // }

  // getReportOwnerCheckingAccountPDF(carrierId:number, ownerId:number, startDate: string, endDate: string, sort: string, column: string, languageCode: string, find?: string, movementFilter?){
  //   let reportOwnerCheckingAccount = new ReportOwnerCheckingAccount();

  //   reportOwnerCheckingAccount.setParameters({
  //     carrierId: carrierId,
  //     ownerId: ownerId,
  //     from: startDate,
  //     to: endDate,
  //     sort: sort,
  //     column: column,
  //     find: find,
  //     movementFilter: movementFilter,
  //     languageCode: languageCode
  //   });
  //   return this._connectionService
  //     .Request(reportOwnerCheckingAccount)
  //     .map((response) => {
  //       console.log('...pdf...');
  //       return response;
  //     })
  //     .catch((error) => {
  //       this._notificationService.showHttpErrorMessage(
  //         'toast.checking_accounts.detail',
  //         error
  //       );
  //       return Observable.throw(false);
  //     });
  // }

  // getReportDriverCheckingAccountPDF(carrierId:number, driverId:number, startDate: string, endDate: string, sort: string, column: string, languageCode: string, movementFilter?){
  //   let reportDriverCheckingAccount = new ReportDriverCheckingAccount();

  //   reportDriverCheckingAccount.setParameters({
  //     carrierId: carrierId,
  //     driverId: driverId,
  //     from: startDate,
  //     to: endDate,
  //     sort: sort,
  //     column: column,
  //     movementFilter: movementFilter,
  //     languageCode: languageCode
  //   });
  //   return this._connectionService
  //     .Request(reportDriverCheckingAccount)
  //     .map((response) => {
  //       console.log('...pdf...');
  //       return response;
  //     })
  //     .catch((error) => {
  //       this._notificationService.showHttpErrorMessage(
  //         'toast.checking_accounts.detail',
  //         error
  //       );
  //       return Observable.throw(false);
  //     });
  // }

  // getAdminCheckingAccountTotals(
  //   carrierId: number
  // ): Observable<AdminCheckingAccountTotalsResponseDTO> {
  //   const adminCheckingAccountSummaryTotalsCommand =
  //     new GetAdminCheckingAccountSummaryTotalsCommand();
  //   adminCheckingAccountSummaryTotalsCommand.setParameters(<
  //     IGetAdminCheckingAccountSummaryTotalsCommandParameters
  //   >{
  //     carrierId: carrierId,
  //   });
  //   return this._connectionService
  //     .Request(adminCheckingAccountSummaryTotalsCommand)
  //     .map((response) => {
  //       return response;
  //     })
  //     .catch((error) => {
  //       this._notificationService.showHttpErrorMessage(
  //         'toast.checking_accounts.title',
  //         error
  //       );
  //       return Observable.throw(false);
  //     });
  // }

  // saveAdminCheckingAccountMovement(
  //   checkingAccountId: number,
  //   note: CreditDebitNoteRequestDTO
  // ) {
  //   const checkingAccountMovementsCommand =
  //     new AddAdminCheckingAccountMovementCommand();
  //   checkingAccountMovementsCommand.setIds(checkingAccountId);
  //   checkingAccountMovementsCommand.setCommandBody({
  //     amount: note.amount,
  //     noteType: note.noteType,
  //     reason: note.reason,
  //   });
  //   return this._connectionService
  //     .Request(checkingAccountMovementsCommand)
  //     .map((response) => {
  //       return response;
  //     })
  //     .catch((error) => {
  //       this._notificationService.showHttpErrorMessage(
  //         'toast.checking_accounts.title',
  //         error
  //       );
  //       return Observable.throw(false);
  //     });
  // }

  // getReportAdminCheckingAccountPDF(
  //   carrierId: number,
  //   paymentMethod: string,
  //   startDate: string,
  //   endDate: string,
  //   sort: string,
  //   column: string
  // ) {
  //   let reportAdminCheckingAccount = new ReportAdminCheckingAccountCommand();

  //   reportAdminCheckingAccount.setParameters({
  //     carrierId: carrierId,
  //     paymentMethod: paymentMethod,
  //     from: startDate,
  //     to: endDate,
  //     sort: sort,
  //     column: column,
  //   });
  //   return this._connectionService
  //     .Request(reportAdminCheckingAccount)
  //     .map((response) => {
  //       console.log('...pdf...');
  //       return response;
  //     })
  //     .catch((error) => {
  //       this._notificationService.showHttpErrorMessage(
  //         'toast.checking_accounts.detail',
  //         error
  //       );
  //       return Observable.throw(false);
  //     });
  // }

  // downloadPdf(checkingAccountPdfDto) {
  //   let getMovementPdf = new GetMovementsPdfByIdCommand();

  //   getMovementPdf.setParameters({
  //     checkingAccountId: checkingAccountPdfDto.checkingAccountId,
  //     carrierId: checkingAccountPdfDto.carrierId,
  //     dateFilter: checkingAccountPdfDto.dateFilters,
  //   });

  //   return this._connectionService
  //     .Request(getMovementPdf)
  //     .map((response) => {
  //       return response;
  //     })
  //     .catch((error) => {
  //       this._notificationService.showHttpErrorMessage(
  //         'toast.surrenders.title',
  //         error
  //       );
  //       return Observable.throw(false);
  //     });
  // }

  // getCheckingAccountFirstMovement(checkingAccountId: number) {
  //   const checkingAccountFirstMovementDateCommand =
  //     new GetCheckingAccountFirstMovementDateCommand();
  //   checkingAccountFirstMovementDateCommand.setParameters({
  //     checkingAccountId: checkingAccountId,
  //   });
  //   return this._connectionService
  //     .Request(checkingAccountFirstMovementDateCommand)
  //     .map((response) => {
  //       return response;
  //     })
  //     .catch((error) => {
  //       this._notificationService.showHttpErrorMessage(
  //         'toast.checking_accounts.magiis',
  //         error
  //       );
  //       return Observable.throw(false);
  //     });
  // }


  // getMovementType(
  //   carrierId: number,
  //   type: string
  // ) {
  //   const command = new GetCheckingAccountMovementTypeCommand();
  //   command.setParameters(<
  //     IGetCheckingAccountMovementTypeCommandParameter
  //     >{
  //       carrierId: carrierId,
  //       type: type
  //     });
  //   return this._connectionService
  //     .Request(command)
  //     .map(response => {
  //       return response;
  //     })
  //     .catch(error => {
  //       this._notificationService.showHttpErrorMessage(
  //         'toast.shared.error_code.0',
  //         error
  //       );
  //       return Observable.throw(false);
  //     });
  // }

  // getCompanies(
  //   affiliateId: number,
  // ):Observable<CompanyCheckingAccountResponseDTO[]> {
  //   const command = new GetCompaniesCheckingAccountCommad();
  //   command.setParameters({
  //       affiliateId: affiliateId,
  //     });
  //   return this._connectionService
  //     .Request(command)
  //     .map(response => {
  //       return response;
  //     })
  //     .catch(error => {
  //       this._notificationService.showHttpErrorMessage(
  //         'toast.shared.error_code.0',
  //         error
  //       );
  //       return Observable.throw(false);
  //     });
  // }

  _addCheckingAccountLiquidation(
    allMovements: boolean,
    movementOwnerId: number,
    movements: Array<any>,
    notes: string,
    paymentType: string,
    proccesDate: Date,
    tag: string,
    travelId: number,
    checkingAccountId: number
  ): Observable<any> {
    const command = new AddCheckingAccountLiquidationCommand();
    command.setParameters({
      allMovements: allMovements,
      movementOwnerId: movementOwnerId,
      movements: movements,
      notes: notes,
      paymentType: paymentType,
      proccesDate: proccesDate,
      tag: tag,
      travelId: travelId,
      checkingAccountId: checkingAccountId,
    });
    return this._connectionService
      .Request(command)
      .pipe(
        map((response) => response),
        catchError(() => throwError(() => false))
      );
  }

  _getAffiliateLiquidation(
    checkingAccountId: number,
    liquidationId: number,
    affiliateId: number,
    column: string,
    page: number,
    size: number,
    sort: string
  ): Observable<GetAffiliateLiquidationDTO> {
    const command = new GetAffiliateLiquidationCommand();
    command.setParameters({
      checkingAccountId: checkingAccountId,
      liquidationId: liquidationId,
      affiliateId: affiliateId,
      column: column,
      page: page,
      size: size,
      sort: sort,
    });
    return this._connectionService
      .Request(command)
      .pipe(
        map((response) => response as GetAffiliateLiquidationDTO),
        catchError(() => throwError(() => false))
      );
  }

  _cancelAffiliateLiquidation(
    checkingAccountId: number,
    liquidationId: number
  ): Observable<any> {
    const command = new DeleteAffiliateLiquidationCommand();
    command.setParameters({
      checkingAccountId: checkingAccountId,
      liquidationId: liquidationId,
    });
    return this._connectionService
      .Request(command)
      .pipe(
        map((response) => response),
        catchError(() => throwError(() => false))
      );
  }
}
